import { AxiosResponse } from "axios";
import BaseApi from "../base/BaseApi";


interface LoginRequestBody {
    username: string;
    password: string;
    franchise: number;
}

interface RequestHeader {
    Authorization: string;
    'Content-Type': string
    version: '2.0.0',
    source: 'popina' | 'jalia'
}

interface LoginResponse {
    token: string
    refresh_token: string
}

export interface Franchise {
    id: number
    token: string
    name: string
    shops: Shop[]
}

export interface Shop {
    id: number
    name: string
    token: string
    refresh_token: string
    logoUrl: string
    franchise?: {
        token?: string
    }
}

export default class FoxOrderApi extends BaseApi {
    public readonly isDev: boolean
    public readonly isPopina: boolean

    constructor(isDev: boolean, isPopina: boolean) {
        super(
            isDev ? "https://staging-foxorders.fr/api/v2/" : "https://foxorders.fr/api/v2/",
            false
        );
        this.isDev = isDev;
        this.isPopina = isPopina;
    }

    private header = (token: string): RequestHeader => {
        return {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            version: "2.0.0",
            source: this.isPopina ? "popina" : "jalia"
        }
    }

    async authenticateFoxOrderUser(username: string, password: string, franchise: number, uid: string): Promise<LoginResponse> {
        const body: LoginRequestBody = { username: username, password: password, franchise: franchise };
        try {
            const authentication: AxiosResponse<LoginResponse> = await this.postRequest("login", { 'Content-Type': 'application/json' }, body);
            return authentication.data as LoginResponse
        } catch (error) {
            if (error instanceof Error) {
                console.error(error.message)
            }
            throw error
        }
    }

    async getFranchiseFromID(franchise: number, token: string): Promise<Franchise> {
        try {
            const franchiseData = await this.getRequest(`franchises/${franchise}`, this.header(token))
            return franchiseData.data as Franchise
        } catch (error) {
            if (error instanceof Error) {
                console.error(error.message)
            }
            throw error
        }
    }

    async getShopFromID(shop: number, token: string) {
        try {
            const shopData = await this.getRequest(`shops/${shop}`, this.header(token))
            return shopData.data as Shop
        } catch (error) {
            if (error instanceof Error) {
                console.error(error.message)
            }
            throw error
        }
    }
}